var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"25","height":"19","viewBox":"0 0 25 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.47832 18.6926L0.43457 10.6489L2.73232 8.35112L8.48076 14.0931L8.47832 14.0955L22.2664 0.307373L24.5642 2.60512L10.7761 16.3949L8.47995 18.691L8.47832 18.6926Z","fill":"#3FB522"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }